export default Object.assign(
  JSON.parse(
    JSON.stringify(require("models/block/blocks/command/blueprints/wait.json")),
  ), //make sure all the values are deeply cloned
  {
    groups: ["year 3", "year 4", "year 5", "year 6"],
    "editorial-only": true,
    args: {
      arguments: [
        {
          code: {
            type: "number",
            value: null,
            title: "number",
            "hard-lock": true,
            editable: true,
          },
        },
      ],
    },
  },
);
